module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageMetaDescription":"Tag Utenti","newSkill":"Nuovo tag","agencySkillDelete":"Tag eliminato con successo","agencySkillDeleteError":"Impossibile eliminare il tag","editSkill":"Modifica tag","formSkillDetails":{"Name":"Tag","IsActive":"Attivo?"},"tagAdded":"Tag creato!"}}')
  delete Component.options._Ctor
}
